import { render, staticRenderFns } from "./S12Ui.vue?vue&type=template&id=1ee338fc&scoped=true&"
import script from "./S12Ui.vue?vue&type=script&lang=js&"
export * from "./S12Ui.vue?vue&type=script&lang=js&"
import style0 from "./S12Ui.vue?vue&type=style&index=0&id=1ee338fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee338fc",
  null
  
)

export default component.exports